import React, { PropsWithChildren, useState } from "react";
import { IconName } from "../components/Icon";

export type DynamicButtonConfig = {
    title: string;
    shortTitle?: string;
    icon?: IconName;
    onClick: () => void;
};

interface ScreenHeaderContextInterface {
    setDynamicButtonConfig: (value?: DynamicButtonConfig) => void;
    dynamicButtonConfig?: DynamicButtonConfig;
    setIsScreenScrolled: (value: boolean) => void;
    isScreenScrolled: boolean;
}

export const ScreenHeaderManagerContext = React.createContext<ScreenHeaderContextInterface>({
    setDynamicButtonConfig: () => {},
    dynamicButtonConfig: { title: "", onClick: () => {} },
    setIsScreenScrolled: () => {},
    isScreenScrolled: false,
});

const ScreenHeaderManager = ({ children }: PropsWithChildren) => {
    const [isScreenScrolled, setIsScreenScrolled] = useState(false);
    const [dynamicButtonConfig, setDynamicButtonConfig] = useState<DynamicButtonConfig>();

    return (
        <ScreenHeaderManagerContext.Provider
            value={{
                setDynamicButtonConfig,
                dynamicButtonConfig,
                setIsScreenScrolled,
                isScreenScrolled,
            }}
        >
            {children}
        </ScreenHeaderManagerContext.Provider>
    );
};

export default ScreenHeaderManager;
